import React, { useState } from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import DiceScreen from './DiceScreen';
import MinesScreen from './MinesScreen';

type GameType = 'menu' | 'dice' | 'mines';

const GamesScreen = () => {
  const { t } = useLanguage();
  const [currentGame, setCurrentGame] = useState<GameType>('menu');

  // Если выбрана конкретная игра - показываем её
  if (currentGame === 'dice') {
    return <DiceScreen />;
  }

  if (currentGame === 'mines') {
    return <MinesScreen />;
  }

  // Меню выбора игры
  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-600 to-purple-700 pb-20 px-4 pt-6">
      <div className="card bg-gradient-to-br from-indigo-700/80 to-purple-800/80 text-white text-center mb-4">
        <div className="text-3xl font-bold mb-2">{t.gamesTitle}</div>
        <div className="text-sm opacity-90">{t.chooseGame}</div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* 1 to 100 Game Card */}
        <button
          onClick={() => setCurrentGame('dice')}
          className="card bg-gradient-to-br from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white transition-all transform hover:scale-105"
        >
          <div className="text-6xl mb-3">🎯</div>
          <h3 className="text-2xl font-bold mb-2">{t.game1to100}</h3>
          <p className="text-sm opacity-90 mb-4">
            {t.game1to100Desc}
          </p>
          <div className="bg-white/20 rounded-lg p-2">
            <div className="text-xs">{t.minBet}: 0.1 TON</div>
            <div className="text-xs">{t.houseEdge}: 2%</div>
            <div className="text-xs mt-1 text-yellow-300">⏱️ {t.gamesInfoDailyLimit}</div>
          </div>
        </button>

        {/* MINES Game Card */}
        <button
          onClick={() => setCurrentGame('mines')}
          className="card bg-gradient-to-br from-blue-600 to-cyan-600 hover:from-blue-700 hover:to-cyan-700 text-white transition-all transform hover:scale-105"
        >
          <div className="text-6xl mb-3">💣</div>
          <h3 className="text-2xl font-bold mb-2">{t.gameMines}</h3>
          <p className="text-sm opacity-90 mb-4">
            {t.gameMinesDesc}
          </p>
          <div className="bg-white/20 rounded-lg p-2">
            <div className="text-xs">{t.minBet}: 0.1 TON</div>
            <div className="text-xs">{t.houseEdge}: 2%</div>
            <div className="text-xs mt-1 text-yellow-300">⏱️ {t.gamesInfoDailyLimit}</div>
          </div>
        </button>
      </div>

      {/* Info */}
      <div className="card bg-white/80 mt-4">
        <h3 className="font-bold text-lg mb-3">{t.gamesInfo}</h3>
        <ul className="list-disc list-inside space-y-2 text-sm text-gray-700">
          <li>{t.gamesInfoFair}</li>
          <li>{t.gamesInfoInstant}</li>
          <li>{t.gamesInfoMinBet}</li>
          <li>{t.gamesInfoHouseEdge}</li>
          <li>{t.gamesInfoDailyLimit}</li>
        </ul>
      </div>
    </div>
  );
};

export default GamesScreen;
